<template>
    <div class="table-responsive">
        <base-table class="table align-items-center table-flush"
                    tbody-classes="list"
                    :data="forms">
            <template slot="columns">
                <th>Name</th>
                <th>Beschreibung</th>
                <th>Fragen</th>
            </template>
            <template slot-scope="{row,index}">
                <th scope="row">
                        <div class="media align-items-center">
                            <div v-if="isLoading" class="loading-button"> </div><div v-else>
                            <base-button type="primary" v-on:click="selectedForm=index" icon="fas fa-chevron-circle-right" icon-only></base-button> </div>
                            <div class="media-body">
                                <div v-if="isLoading" class="loading"> </div><div v-else>
                                <span v-html="row.name" class="name mb-0 text-sm"></span></div>
                            </div>
                        </div>
                </th>
                <td v-html="row.description"  class="budget">
                    <div v-if="isLoading" class="loading"> </div>
                </td>
                <td>
                    <div v-if="isLoading" class="loading"> </div><div v-else>
                        <badge class="badge-dot mr-4" type="info">
                            <i class="`bg-info`"></i>
                            <span class="status">{{(row.questions) ? row.questions.length : 0 }}</span>
                        </badge>
                    </div>
                </td>

            </template>
        </base-table>
    </div>
</template>
<script>
    export default {
        name: 'SelectForm',
        data() {
            return {
                selectedForm: null,
                totalitems: 0,
                page: 1,
                isLoading: false,
                forms: [{
                    name: '',
                    description: ''
                }],
            }
        },
        props: {
            location : null
        },
        methods: {
            getForms() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    let url = process.env.VUE_APP_API_SERVER + `/api/location_forms?form.isActive=true&location=`+this.location+`&pagination=false`;
                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });
                                this.isLoading = false;
                            },
                            error => {
                                reject(error);
                                this.isLoading = false;
                            });
                });
            },

        }
    }
</script>